module.exports = __webpack_public_path__ + "img/Betting_text05c_prevent.3ee99590.png";